/* eslint-disable react/jsx-props-no-spreading */

import React, { } from 'react';
import {
   Box,
   Table,
   TableBody,
   TableCell,
   TableHead,
   TableRow,
 } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

const ChildTable = ({columns, data, style}) => {
   const isPhone = useMediaQuery({ query: '(max-width: 768px)' });

   if(isPhone){
      return (<Box>
         {isPhone}
      </Box>)
   }

   return (
      <Table>
         <TableHead style={style?.tableHead || {}}>
            {columns.map((col) => (
               <TableCell 
                  style={style?.headCell || {}}
                  {...col.headerProps}
               >
                  {col.header}
               </TableCell>))}
         </TableHead>
         <TableBody>
            {data.length > 0? data.map((row) => (
               <TableRow style={{backgroundColor: '#f9fcff'}}>
                  {columns.map((col) => (
                     <TableCell style={col.cellStyle || {}}>
                        {col.cell? col.cell(row): row[col.key]}
                     </TableCell>))}
               </TableRow>)):
               (<TableRow>
                  <TableCell colSpan={columns.length}>
                     No Data Available
                  </TableCell>
               </TableRow>)}
         </TableBody>
      </Table>);
 };

 ChildTable.propTypes = {
   columns: PropTypes.arrayOf(PropTypes.obj),
   data: PropTypes.arrayOf(PropTypes.obj),
   style: PropTypes.shape({
      tableHead: PropTypes.shape({
      }),
      headCell: PropTypes.shape({
      }),
    }),
 };

 ChildTable.defaultProps = {
   columns: [],
   data: [],
   style: {},
 };

 export default ChildTable;